import {
  DayOfMonth,
  DayOfMonthOptions,
  DayOfWeek,
  DayOfWeekOptions,
  MonthOfYearOptions
} from "../components/controls/ScheduleSelector";
import {dateToLocalFormat} from "../stores/StoreUtilities";

export enum ScheduleNames {
  None = "None",
  Once = "Once",
  Daily = "Daily",
  Weekly = "Weekly",
  BiWeekly = "Bi-weekly",
  SemiMonthly = "Semi-monthly",
  Monthly = "Monthly",
  Quarterly = "Quarterly",
  SemiAnnual = "Semi-Annual",
  Annual = "Annual",
  Custom = "Custom"
}

export enum Frequency {
  Once = "Once",
  Daily = "Daily",
  Weekly  = "Weekly",
  Monthly = "Monthly",
  Yearly = "Yearly"
}


class Schedule {
  name: string
  frequency: Frequency
  interval: number
  each?: Array<number>
  on?: Array<number> | Array<string>

  constructor (data: any) {
    if (data) {
      if (typeof data === "string") {
        data = JSON.parse(data)
      }
      this.name = data.name
      this.frequency = data.frequency ? (Frequency as any)[data.frequency] : Frequency.Once
      this.interval = data.interval ?? 1
      this.each = data.each
      this.on = data.on
    } else {
      this.name = "Once"
      this.frequency = Frequency.Once
      this.interval = 1
    }
  }

  getDescription(startDate?: Date, detailed?: boolean): string {

    if (this.name !== "Custom" && !detailed) {
      return this.name
    } else {
      let freq = ""
      let on = ""
      let of = ""
      switch (this.frequency) {
        case Frequency.Once:
          freq = "Once"
          if (startDate) {
            on = ` on ${dateToLocalFormat(startDate, "MMM d, yyyy")}`
          } else {
            on = ` on start date`
          }
          break
        case Frequency.Daily:
          freq = this.interval > 1 ? `Every ${this.interval} Days` : "Daily"
          break
        case Frequency.Weekly:
          freq = this.interval > 1 ? `Every ${this.interval} Weeks` : "Weekly"
          if (this.on && this.on.length > 0) {
            const weekday = this.on[0]
            const day = DayOfWeekOptions.find((option: DayOfWeek) => option.weekday === weekday)
            if (day) {
              on = ` on ${day.label}`
            }
          } else {
            on = ` on Mon`
          }
          break
        case Frequency.Monthly:
          freq = this.interval > 1 ? `Every ${this.interval} Months` : "Monthly"
          if (this.on && this.on.length > 0) {
            const days = this.on.map((day: number | string) => {
              const dayOfMonth = DayOfMonthOptions.find((option: DayOfMonth) => option.day === day)
              if (dayOfMonth) {
                return dayOfMonth.label
              } else {
                return ""
              }
            })
            on = ` on ${days.join(", ")}`
          } else {
            on = ` on last day`
          }
          break
        case Frequency.Yearly:
          freq = this.interval > 1 ? `Every ${this.interval} Years` : "Yearly"
          if (this.on && this.on.length > 0) {
            const day = this.on[0]
            const dayOfMonth = DayOfMonthOptions.find((option: DayOfMonth) => option.day === day)
            if (dayOfMonth) {
              on = ` on ${dayOfMonth.label.toLowerCase()}`
            }
          }
          if (this.each && this.each.length > 0) {
            const months = this.each.map((month: number) => MonthOfYearOptions[month-1].label)
            of = ` of ${months.join(", ")}`
          } else {
            if (startDate) {
              of = ` of ${MonthOfYearOptions[startDate.getMonth()].label}`
            } else {
              of = ` of start month`
            }
          }
          break
      }
      if (detailed === false && (on || of)) {
        return `${this.frequency}...`
      } else {
        return `${freq}${on}${of}`
      }
    }
  }

  // nextDate(date: Date): Date | null {
  //   if (this.frequency === Frequency.Weekly) {
  //     return addWeeks(date, this.interval)
  //   } else if (this.frequency === Frequency.Monthly) {
  //     return addMonths(date, this.interval)
  //   } else if (this.frequency === Frequency.Yearly) {
  //     return addYears(date, this.interval)
  //   } else {
  //     return null
  //   }
  // }

  static defaultSchedules: Schedule[] = [
    new Schedule({name: "Once", frequency: Frequency.Once, interval: 1}),
    new Schedule({name: "Weekly", frequency: Frequency.Weekly, interval: 1}),
    new Schedule({name: "Bi-weekly", frequency: Frequency.Weekly, interval: 2}),
    new Schedule({name: "Monthly", frequency: Frequency.Monthly, interval: 1, on: [-1]}),
    new Schedule({name: "Semi-monthly", frequency: Frequency.Monthly, interval: 1, on: [1, 15]}),
    new Schedule({name: "Quarterly", frequency: Frequency.Yearly, interval: 1, each:[1,4,7,10], on: [1]}),
    new Schedule({name: "Semi-annual", frequency: Frequency.Yearly, interval: 1, each:[1,7], on: [1]}),
    new Schedule({name: "Yearly", frequency: Frequency.Yearly, interval: 1, on: [-1]}),
    // TODO: new Schedule({name: "Custom"})
  ]

  static getDefaultSchedule(name: string) {
    return this.defaultSchedules.find((option: Schedule) => option.name === name)
  }
}

export default Schedule